import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';

export class PasswordStrengthService {

  // @Input() class:string = '';
  // @Input() id:string = '';



  // public width = 1;
  private value: string;
  private pass: string ; 

   public stength = 'Weak Password';
    public pclass = 'warn';
  



//minimum 8 characters
 bad = /(?=.{8,}).*/;
//Alpha Numeric plus minimum 8
 good = /^(?=\S*?[a-z])(?=\S*?[0-9])\S{8,}$/;
//Must contain at least one upper case letter, one lower case letter and (one number OR one special char).
 better = /^(?=\S*?[A-Z])(?=\S*?[a-z])((?=\S*?[0-9])|(?=\S*?[^\w\*]))\S{8,}$/;
//Must contain at least one upper case letter, one lower case letter and (one number AND one special char).
 best = /^(?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9])(?=\S*?[^\w\*])\S{8,}$/;

onKey(event: any) {

    this.pass = event.target.value;
     
    if (this.best.test(this.pass) == true) {
        this.stength = 'Very Strong Password';
        this.pclass = 'accent';
       
    } else if (this.better.test(this.pass) == true) {
        this.stength = 'Strong Password';
        this.pclass = 'accent';
       
    } else if (this.good.test(this.pass) == true) {
        this.stength = 'Almost Strong Password';
        this.pclass = 'accent';
        
    } else if (this.bad.test(this.pass) == true) {
        this.stength = 'Weak Password';
         this.pclass = 'warn';
    } else {
        this.stength = 'Very Weak Password';
        this.pclass = 'warn';
    }

    // var popover = password.attr('data-content', stength).data('bs.popover');
    // popover.setContent();
    // popover.$tip.addClass(popover.options.placement).removeClass('danger success info warning primary').addClass(pclass);

} 
}



// $('input[data-toggle="popover"]').popover({
//     placement: 'top',
//     trigger: 'focus'
// });





// WEBPACK FOOTER //
// ./src/app/main/shared/services/password.strength.ts